module.exports = __webpack_public_path__ + "img/svg/background-invite-friend-mobile.1e69b26c3244257b278fb4eadc55bca7.svg";